export default __webpack_public_path__ + "static/media/erp.ec57bb1d.jpg";